module.exports = __webpack_public_path__ + "img/send.4020dabb.png";